function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Group_40",
  "data-name": "Group 40",
  transform: "translate(-263 -345)"
}, React.createElement("circle", {
  id: "Ellipse_1",
  "data-name": "Ellipse 1",
  cx: 12,
  cy: 12,
  r: 12,
  transform: "translate(263 345)",
  fill: "#4bc9c9"
}), React.createElement("path", {
  id: "Path_11",
  "data-name": "Path 11",
  d: "M2294.57,1154.6a.655.655,0,0,1-.464-.192l-2.913-2.908a.657.657,0,1,1,.929-.93l2.448,2.444,5.826-5.817a.657.657,0,0,1,.929.93l-6.291,6.281A.655.655,0,0,1,2294.57,1154.6Z",
  transform: "translate(-2020.891 -794.065)",
  fill: "#fff"
}));

var SvgIconConfirm = function SvgIconConfirm(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconConfirm, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_confirm.2e35ffda.svg";
export { ForwardRef as ReactComponent };